// @flow

import * as React from 'react';

type Props = {
  width?: string,
  height?: string,
  color?: string,
};

export const Expand = ({ width, height, color, className }: Props) => (
  <svg
    viewBox="0 0 14 7"
    width={width || '100%'}
    height={height || '100%'}
    style={{ fill: color || 'currentColor' }}
    className={className}
  >
    <path
      d="M6.67015398,6.89106667 C6.50748731,6.89106667 6.34482065,6.83173333 6.21748731,6.71306667 L0.213487313,1.1564 C-0.0565126873,0.9064 -0.0725126873,0.4844 0.177487313,0.2144 C0.428153979,-0.0562666667 0.848820646,-0.0729333333 1.11948731,0.177733333 L6.66948731,5.31573333 L12.2034873,0.1784 C12.4728206,-0.0722666667 12.8948206,-0.0569333333 13.146154,0.213733333 C13.396154,0.483733333 13.380154,0.905066667 13.1108206,1.15573333 L7.12348731,6.71306667 C6.99615398,6.83173333 6.83282065,6.89106667 6.67015398,6.89106667"
      id="path-1"
    />
  </svg>
);
